import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/videos';

export default function Articles() {
  const { t } = useTranslation();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: t('nav.articles') }]} />

          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-8">
            {t('articles.title')}
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-14">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/article-view/${article.slug}`}
                className="group block bg-background-200/60 hover:bg-background-200 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-video overflow-hidden">
                  <img
                    src={article.thumbnail}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <h2 className="text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 font-heading">
                    {article.title}
                  </h2>
                  <p className="text-foreground-500 text-sm mt-2 line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center gap-3 mt-4 text-xs text-foreground-400">
                    <span className="whitespace-nowrap">
                      <i className="ri-user-line mr-1"></i>
                      {article.author}
                    </span>
                    <span className="whitespace-nowrap">
                      <i className="ri-calendar-line mr-1"></i>
                      {article.date}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}